<template>
  <vs-prompt
    class="personal-evaluation--dialog"
    @cancel="evaluationSkipped"
    @close="evaluationSkipped"
    :buttons-hidden="true"
    :active.sync="showPersonalEvaluation"
  >
    <div class="prompt-body">
      <div class="header">
        <h1 class="mb-3">Personal Evaluation</h1>
        <p>
          The more clear you are about your goals, the closer you are to achieving them.
        </p>
      </div>
      <div class="body">  
        <form-wizard
          class="personal-evaluation--form"
          color="rgba(var(--vs-primary), 1)"
          :title="null"
          :subtitle="null"
          nextButtonText="Continue"
          finishButtonText="Submit"
          @on-complete="formSubmitted"
        >
          <tab-content title="Type of Work" class="mb-5">
            <!-- tab 1 content -->
            <vs-row>
              <h3 class="mb-4">What kind of work do you want to do?</h3>
              <vs-input
                class="w-full"
                name="Type Of Work"
                :disabled="disableInputField"
                v-model="localPersonalEvaluationData.typeOfWork"
                @blur="saveField('saveTypeOfWork')"
              />
            </vs-row>
          </tab-content>

          <tab-content title="Industry" class="mb-5">
            <!-- tab 1 content -->
            <vs-row>
              <h3 class="mb-4">
                Which field do you want to grow in?
              </h3>
              <vs-input
                class="w-full"
                name="Industry"
                :disabled="disableInputField"
                v-model="localPersonalEvaluationData.industry"
                @blur="saveField('saveIndustry')"
              />
            </vs-row>
          </tab-content>

          <tab-content title="Location" class="mb-5">
            <!-- tab 1 content -->
            <vs-row>
              <h3 class="mb-4">Where do you want to work?</h3>
              <vs-input
                class="w-full"
                name="Location"
                :disabled="disableInputField"
                v-model="localPersonalEvaluationData.location"
                @blur="saveField('saveLocation')"
              />
            </vs-row>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

// import FeatherIcon from "../../components/FeatherIcon.vue";
// import Options from "./components/Options.vue";
// import constants from "@/constants";
import { saveInputFieldService } from "@/services/editor/personalEvaluation.service.js";
// import _ from "lodash";

export default {
  data() {
    return {
      localPersonalEvaluationData: {},
    };
  },
  computed: {
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    personalEvaluation() {
      return this.$store.state.editor.personalEvaluation;
    },
    showPersonalEvaluation: {
      get() {
        if (this.isUserLoggedIn && Object.keys(this.localPersonalEvaluationData).length) {
          if (
            this.personalEvaluation.skipped === true ||
            this.personalEvaluation.submitted === true
          ) {
            return false;
          } else {
            return true;
          }
        }
        return false;
      },
      set() {
        return;
      },
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
        if (this.localData.dob) {
          this.localData.dob = this.localData.dob.split("T")[0];
        }
      }
    },
    personalEvaluation(newVal) {
      if (newVal) {
        // console.log(newVal);
        this.localPersonalEvaluationData = JSON.parse(JSON.stringify(newVal));
      }
    },
  },
  methods: {
    formSubmitted() {
      this.localPersonalEvaluationData.submitted = true;
      this.saveField("savePESubmitted");
    },
    evaluationSkipped() {
      this.localPersonalEvaluationData.skipped = true;
      this.saveField("savePESkipped");
    },
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        localPersonalEvaluationData: this.localPersonalEvaluationData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);
    },
  },
  components: {
    FormWizard,
    TabContent,
  },
  mounted() {},
  created() {
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);

    //// console.log("contact created");

    if (this.isUserLoggedIn) {
      if (this.usersData && Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        //// console.log(this.localData);
      }
      if (this.personality && Object.keys(this.personality).length) {
        this.localPersonalEvaluationData = JSON.parse(
          JSON.stringify(this.personalEvaluation)
        );
      }
    }
  },
};
</script>

<style scoped>
.personal-evaluation--dialog.con-vs-dialog >>> .vs-dialog-header {
  display: none!important;;
}

.personal-evaluation--dialog.con-vs-dialog >>> .vs-dialog-text {
  padding: 0;
}

.personal-evaluation--dialog.con-vs-dialog >>> .header {
  padding: 3rem!important;
  background: rgba(242, 147, 0, 0.1);
}

.personal-evaluation--dialog.con-vs-dialog >>> .header h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height */
  color: #F29300;
}

.personal-evaluation--dialog.con-vs-dialog >>> .header p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 162% */
  color: rgba(242, 147, 0, 0.9);
}

.personal-evaluation--dialog.con-vs-dialog >>> .body {
  padding: 0 3rem 3rem 3rem!important;
}

.personal-evaluation--dialog.con-vs-dialog >>> .vs-dialog {
  width: calc(100% - 30px) !important;
  max-width: 800px !important;
}

.personal-evaluation--form.vue-form-wizard {
  padding-bottom: 0!important;
}

.personal-evaluation--form.vue-form-wizard >>> .wizard-icon-container {
  border-radius: 50% !important;
}

.personal-evaluation--form.vue-form-wizard >>> button {
  /* Auto Layout */

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 11px 35px;

  border-radius: 100px;

  font-style: normal!important;
  font-weight: 600!important;
  font-size: 18px!important;
  line-height: 22px!important;
  /* identical to box height */

  text-align: center!important;
  letter-spacing: -0.02em!important;
  color: #FFFFFF!important;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}


.personal-evaluation--form > .wizard-card-footer .wizard-footer-left > button {
  /* Auto Layout */

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 11px 35px;

  background: #ffffff !important;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 100px;
}
</style>